import { c as _c } from "react/compiler-runtime";
import { useLocalize } from "@faro-lotv/foreign-observers";
import { DateTimeUtils } from "@stellar/utils";
import { DateTime } from "luxon";

/**
 * Formats a date following the locale-specific CLDR medium date format.
 * Omits the year when the date is in the current year and the shouldShowYear flag is false.
 */

/** @returns the date input as a luxon DateTime */
function toDateTime(date) {
  if (date instanceof Date) {
    return DateTime.fromJSDate(date);
  }
  return typeof date === "number" ? DateTime.fromMillis(date) : DateTime.fromISO(date);
}

/**
 * Hook to format and translate dates
 *
 * Uses locale-specific absolute dates per CLDR medium date format,
 * For dates within the last 7 days, provides relative formatting
 * with an absolute-date tooltip for hover display.
 *
 * @returns Formatting functions bound to the current user language
 */
export function useDateTime() {
  const $ = _c(2);
  const {
    currentLanguage
  } = useLocalize();
  const languageCode = currentLanguage.code;
  let t0;
  if ($[0] !== languageCode) {
    t0 = {
      formatDate: date => DateTimeUtils.formatAbsoluteDate({
        date,
        languageCode
      }),
      formatDateWithTooltip: date_0 => {
        const {
          formattedDate,
          absoluteDate
        } = DateTimeUtils.formatDateDisplay({
          date: date_0,
          languageCode
        });
        return {
          displayDate: formattedDate,
          tooltipDate: absoluteDate
        };
      },
      formatDateTime: date_1 => {
        const dateTime = toDateTime(date_1);
        return dateTime.isValid ? dateTime.setLocale(languageCode).toLocaleString(DateTime.DATETIME_MED) : "";
      }
    };
    $[0] = languageCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}